import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Line, { x1: "7", x2: "17", y1: "17", y2: "7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Polyline, { points: "7 7 17 7 17 17", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "ArrowUpRight";
const ArrowUpRight = memo(themed(Icon));
export {
  ArrowUpRight
};
//# sourceMappingURL=arrow-up-right.js.map
